import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { FixedPaymentFieldWUT } from '../../../ui/fixed-payment-field';
export const FixedPaymentWUT = props => {
  const {
    fieldType = FIELD_TYPES.FIXED_PAYMENT
  } = props;
  return /*#__PURE__*/React.createElement(FixedPaymentFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=fixed-payment-wut.js.map